var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40.0045C31.0078 40.0069 40.0019 31.0165 40.0043 20.0088C40.0067 9.00104 31.0164 0.00685286 20.0086 0.00448268C9.00086 0.00211251 0.00667656 8.99242 0.00430638 20.0002C0.0019362 31.0079 8.99225 40.0021 20 40.0045ZM20.0083 1.24479C30.3959 1.24703 38.7662 9.62093 38.764 20.0085C38.7618 30.3961 30.3879 38.7664 20.0003 38.7642C9.61267 38.7619 1.24238 30.388 1.24462 20.0004C1.24685 9.61285 9.62075 1.24256 20.0083 1.24479Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.703 15.5066C11.0131 15.5066 11.3232 15.1966 11.3233 14.8865L11.3238 12.4059L28.8432 12.4097L28.8427 14.8903C28.8426 15.2004 29.1526 15.5105 29.4627 15.5106C29.7728 15.5107 30.0829 15.2007 30.083 14.8906L30.0836 12.0999C30.0837 11.6348 29.6187 11.1696 29.1535 11.1695L11.014 11.1656C10.5489 11.1655 10.0837 11.6305 10.0836 12.0956L10.083 14.8863C10.0829 15.1964 10.3929 15.5065 10.703 15.5066Z",
    fill: "#00AEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4705 15.0432C20.3155 14.8881 20.1605 14.8881 20.0055 14.8881C19.8504 14.888 19.6954 14.888 19.5403 15.043L14.2679 20.3132C14.1128 20.4682 14.1127 20.9333 14.2677 21.0884C14.4227 21.2434 14.8878 21.2435 15.0429 21.0885L19.3849 16.7484L19.3818 31.167C19.3817 31.4771 19.6917 31.7872 20.0018 31.7873C20.3119 31.7873 20.622 31.4773 20.6221 31.1673L20.6252 16.9037L25.1204 21.2457C25.2754 21.4008 25.7405 21.4009 25.8956 21.2459C26.0506 21.0909 26.0507 20.6258 25.8957 20.4707L20.4705 15.0432Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateStatusIcon);
export default __webpack_public_path__ + "static/media/updateStatusIcon.cf398e86fc1f5e965e755eee3b286e98.svg";
export { ForwardRef as ReactComponent };